import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=42abe8d5&scoped=true&"
import script from "./RatingQuestion.vue?vue&type=script&lang=js&"
export * from "./RatingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RatingQuestion.vue?vue&type=style&index=0&id=42abe8d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42abe8d5",
  null
  
)

export default component.exports